import { queryOptions } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

export const fiscalizationKeys = {
  all: () => ['fiscalization'] as const,
  cashiers: () => [...fiscalizationKeys.all(), 'cashiers'] as const,
  receipts: () => [...fiscalizationKeys.all(), 'receipts'] as const,
  receipt: (url: string) =>
    [...fiscalizationKeys.all(), 'receipt', url] as const,
};

export const fiscalizationQueries = {
  receipt: (url: string) =>
    queryOptions({
      queryKey: fiscalizationKeys.receipt(url),
      queryFn: () =>
        HttpClient.request<string>({
          method: 'GET',
          url,
          headers: { Accept: 'text/html' },
          responseType: 'text',
        }),
      refetchOnWindowFocus: false,
      retry: false,
    }),
};
